import { Helmet } from "react-helmet";
import {
    Autocomplete,
    Box,
    Button,
    Container,
    Checkbox,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    FormControl,
    Grid,
    InputLabel,
    Menu,
    MenuItem,
    Paper,
    Select,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    TextField,
    Toolbar,
    Typography,
    Avatar,
    InputAdornment,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles, withStyles } from "@mui/styles";
import React, { useEffect } from "react";
import cssVariables from "../../theme/cssVariables";
import CloseIcon from "../../assets/images/plus-circle-fill.svg";
import linkedGoal from "../../assets/images/linkedGoal.svg";
import defaultProfile from "../../assets/images/defaultProfile.svg";
import arrowLinkedGoal from "../../assets/images/arrowLinkedGoal.svg";
import kpiArrow from "../../icons/kpiArrow.svg";
import Icon from '@mui/material/Icon';
import fileBrowser from "../../icons/file-browser.svg";
import Search from "@mui/icons-material/Search";

const useStyles = makeStyles({
    boxLeft: {
        width: "25%",
        "padding-bottom": "25px",
    },
    boxRight: {
        width: "75%",
        "padding-bottom": "25px",
    },
});


const DialogIcon = (props) => {
    const { icon, btn, color, open, close, data } = props
    const classes = useStyles();
    const { t } = useTranslation();
    const [valueIcon, setValueIcon] = React.useState('');
    const [search, setSearchValue] = React.useState("");
    const [mainItems, setMainItems] = React.useState([]);
    const [lengthResult, setLengthResult] = React.useState(0);

    useEffect(() => {
        setMainItems(data)
    }, [data]);
    useEffect(() => {
        dataSerachs()
    }, [search]);
    const dataSerachs = (datas) => {
        let result = []
        let dataSerach = JSON.parse(JSON.stringify(datas !== undefined && datas !== null ? datas : data))
        if (search !== "" && dataSerach !== undefined && dataSerach.length > 0) {
            console.log(search);
            let resultData = dataSerach.filter(rs => {
                return Object.keys(rs).some(key => {
                    if (key === 'code' || key === 'name') {
                        return rs[key].toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1;
                    }
                });
            });
            result = resultData
        } else {
            result = dataSerach;
        }
        setLengthResult(result.length);
        setMainItems(result)
    };
    const handleCloseDialog = () => {
        close(false);
    };
    const handleSelectIcon = (datas) => {
        setValueIcon(datas)
    };
    const handleSubmit = () => {
        icon(valueIcon)
        close(false);
    };
    const handleSearch = (event) => {
        setSearchValue(event.target.value);
    };

    return (
        <Dialog onBackdropClick={() => {return false}} open={open} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="lg" PaperProps={{ sx: { padding: '30px 30px 15px' } }}>
            <DialogTitle id="form-add-dialog-title" fontSize={24} lineHeight="26.4px" sx={{ padding: "0 0 20px" }}>
                {t('admin.label.browse')}
                <Box sx={{ position: "absolute", right: 0, margin: "30px 30px 0  0", top: 0 }}><img onClick={handleCloseDialog} className="clickable" src={CloseIcon} alt="browser" /></Box>
            </DialogTitle>
            <Divider />
            <DialogContent sx={{ padding: "0" }}>
                <Box mt={3} mb={2}>
                    <TextField
                        id="input-with-icon-textfield"
                        fullWidth
                        placeholder={t('label.search')}
                        size="small"
                        sx={{ background: "#fff", width: "100%", "input": { padding: "11px 14px" } }}
                        className="searchTextField-h40"
                        value={search}
                        onChange={handleSearch}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Search style={{ color: "#C4C4C4" }} />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <Typography mt={1} fontSize={16} lineHeight="23.92px" >{lengthResult} {t('label.matchingResults')}</Typography>
                </Box>
                <Box sx={{ padding: "0px 0", "overflow-y": "auto !important", "max-height": "450px" }}>
                    <Box sx={{ background: "#E7EBF0", "border-radius": "5px", height: "auto", display: "flex", width: "100%", padding: "11px" }}>
                        <Box sx={{ display: "flex", flexFlow: "row wrap", width: "100%" }}>
                            {mainItems !== undefined && mainItems !== null && mainItems !== "" && mainItems.length > 0 ?
                                mainItems.map(item => (
                                    <Box sx={{ width: "10%", display: "flex", flexDirection: "column", alignItems: "center", padding: "15px 6px" }}>
                                        <Box
                                            sx={{
                                                '&:hover': {
                                                    backgroundColor: "#ffffff", boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
                                                    borderRadius: "5px"
                                                },
                                                transition: "backgroundColor 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                                                width: "100%",
                                                "text-align": "center",
                                                padding: "10px 0px",
                                                cursor: "pointer",
                                                backgroundColor: valueIcon === item.code ? "#ffffff" : 'none',
                                                boxShadow: valueIcon === item.code ? "0px 4px 4px rgba(0, 0, 0, 0.1)" : "none",
                                                borderRadius: valueIcon === item.code ? "5px" : '0px'
                                            }}
                                            onClick={(e) => handleSelectIcon(item.code)}>
                                            <Icon sx={{ fontSize: "30px" }}>{item.code}</Icon>
                                        </Box>
                                        <Typography fontSize={12} lineHeight="14px" sx={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", maxWidth: "100%", paddingTop: "10px", color: "rgba(0, 0, 0, 0.6)" }}>{item.name}</Typography>
                                    </Box>
                                ))
                                : null
                            }
                        </Box>
                    </Box>
                </Box>
                <Grid container mt={3} mb={0}>
                    <Grid item xs display="flex" flexDirection="row-reverse">
                        <Box sx={{ width: "100px" }}>
                            <Button onClick={handleSubmit} color="primary" variant="contained" fullWidth sx={{ textTransform: "none" }}>
                                {t('label.select')}
                            </Button>
                        </Box>
                        <Box mr={2} sx={{ width: "100px" }}>
                            <Button onClick={handleCloseDialog} color="black" variant="outlined" fullWidth sx={{ textTransform: "none" }}>
                                {t('label.cancel')}
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};
export default DialogIcon;
